<template>
  <div>
    <material-card color="#ed2224" title="Sale Enq Via" offset="0">
      <v-layout justify-center wrap>
        <!-- <v-flex xs12>
          <p>Website Email</p>
        </v-flex> -->
        <v-flex xs12>
          <ag-grid-vue
            :style="{ width, height }"
            id="stats-grid"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :animateRows="true"
            :rowBuffer="5"
            :pagination="true"
            rowSelection="multiple"
            :rowDeselection="true"
            @grid-ready="onGridReady"
            @cellDoubleClicked="onCellDoubleClick"
          ></ag-grid-vue>
        </v-flex>
        <!-- <v-flex xs6 style="text-align: center">
          <h3>Website Email</h3>
          <p>
            <span style="font-weight: bold"> # of Enq: </span>
            {{ stats.websiteEnquiries }} ({{
              calculatePercent(stats.websiteEnquiries, stats.enquiriesCount)
            }}%)
          </p>
          <p>
            <span style="font-weight: bold"> Total CC: </span>
            {{ formatMoney(stats.websiteCC) }} ({{
              formatMoney(stats.websiteCC / stats.websiteEnquiries)
            }})
          </p>
        </v-flex>
        <v-flex xs6 style="text-align: center">
          <h3>Repeat</h3>
          <p>
            <span style="font-weight: bold"> # of Enq: </span>
            {{ stats.repeatEnquiries }} ({{
              calculatePercent(stats.repeatEnquiries, stats.enquiriesCount)
            }}%)
          </p>
          <p>
            <span style="font-weight: bold"> Total CC: </span>
            {{ formatMoney(stats.repeatCC) }} ({{
              formatMoney(stats.repeatCC / stats.websiteEnquiries)
            }})
          </p>
        </v-flex>
        <v-flex xs6 style="text-align: center">
          <h3>Call Tracking</h3>
          <p>
            <span style="font-weight: bold"> # of Enq: </span>
            {{ stats.callTrackingEnquiries }} ({{
              calculatePercent(
                stats.callTrackingEnquiries,
                stats.enquiriesCount
              )
            }}%)
          </p>
          <p>
            <span style="font-weight: bold"> Total CC: </span>
            {{ formatMoney(stats.callTrackingCC) }} ({{
              formatMoney(stats.callTrackingCC / stats.websiteEnquiries)
            }})
          </p>
        </v-flex>
        <v-flex xs6 style="text-align: center">
          <h3>Connection Email</h3>
          <p>
            <span style="font-weight: bold"> # of Enq: </span>
            {{ stats.connectionEnquiries }} ({{
              calculatePercent(stats.connectionEnquiries, stats.enquiriesCount)
            }}%)
          </p>
          <p>
            <span style="font-weight: bold"> Total CC: </span>
            {{ formatMoney(stats.connectionCC) }} ({{
              formatMoney(stats.connectionCC / stats.websiteEnquiries)
            }})
          </p>
        </v-flex>
        <v-flex xs6 style="text-align: center">
          <h3>Affiliate Notification</h3>
          <p>
            <span style="font-weight: bold"> # of Enq: </span>
            {{ stats.affiliateEnquiries }} ({{
              calculatePercent(stats.affiliateEnquiries, stats.enquiriesCount)
            }}%)
          </p>
          <p>
            <span style="font-weight: bold"> Total CC: </span>
            {{ formatMoney(stats.affiliateCC) }} ({{
              formatMoney(stats.affiliateCC / stats.websiteEnquiries)
            }})
          </p>
        </v-flex>
        <v-flex xs6 style="text-align: center">
          <h3>Other</h3>
          <p>
            <span style="font-weight: bold"> # of Enq: </span>
            {{ stats.otherEnquiries }} ({{
              calculatePercent(stats.otherEnquiries, stats.enquiriesCount)
            }}%)
          </p>
          <p>
            <span style="font-weight: bold"> Total CC: </span>
            {{ formatMoney(stats.otherCC) }} ({{
              formatMoney(stats.otherCC / stats.websiteEnquiries)
            }})
          </p>
        </v-flex> -->
      </v-layout>
    </material-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import { AgGridVue } from "ag-grid-vue";

  export default {
    props: ["stats"],
    components: {
      AgGridVue,
    },
    data: () => ({
      //AG-Grid
      columnDefs: null,
      rowData: null,
      pinnedBottomRowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "400px",
      search: "",
    }),
    computed: {
      ...mapGetters({
        aGGridActionMenu: "agGrid/aGGridActionMenu",
        selectedRowData: "agGrid/selectedRowData",
      }),
    },
    watch: {
      stats: function () {
        this.formatRowData();
      },
    },
    mounted() {
      this.columnDefs = [
        {
          headerName: "Status",
          field: "name",
        },
        {
          headerName: "# of Enq",
          field: "enqTotal",
          comparator: numberComparator,
          sort: "desc",
        },
        {
          headerName: "% of Total",
          field: "enqPercent",
        },
        {
          headerName: "Total UC",
          field: "ccTotal",
        },
        {
          headerName: "$ per enq (avg)",
          field: "ccPerEnq",
        },
      ];
    },
    methods: {
      formatRowData() {
        if (typeof this.stats != "undefined") {
          let data = JSON.parse(JSON.stringify(this.stats));
          let rowData = [
            {
              name: "Email off Website",
              enqTotal: data.websiteEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.websiteEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.websiteCC),
              ccPerEnq: this.formatMoney(data.websiteCC / data.websiteEnquiries),
            },
            {
              name: "Repeat Sale",
              enqTotal: data.repeatEnquiries,
              enqPercent:
                this.calculatePercent(data.repeatEnquiries, data.enquiriesCount) +
                "%",
              ccTotal: this.formatMoney(data.repeatCC),
              ccPerEnq: this.formatMoney(data.repeatCC / data.repeatEnquiries),
            },
            {
              name: "Call Tracking",
              enqTotal: data.callTrackingEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.callTrackingEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.callTrackingCC),
              ccPerEnq: this.formatMoney(
                data.callTrackingCC / data.callTrackingEnquiries
              ),
            },
            {
              name: "Connection",
              enqTotal: data.connectionEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.connectionEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.connectionCC),
              ccPerEnq: this.formatMoney(
                data.connectionCC / data.connectionEnquiries
              ),
            },
            {
              name: "Affiliate Enquiry",
              enqTotal: data.affiliateEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.affiliateEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.affiliateCC),
              ccPerEnq: this.formatMoney(
                data.affiliateCC / data.affiliateEnquiries
              ),
            },
            {
              name: "Backdoor Sale",
              enqTotal: data.backdoorEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.backdoorEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.backdoorCC),
              ccPerEnq: this.formatMoney(
                data.backdoorCC / data.backdoorEnquiries
              ),
            },
            {
              name: "Alias Email",
              enqTotal: data.aliasEmailEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.aliasEmailEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.aliasEmailCC),
              ccPerEnq: this.formatMoney(
                data.aliasEmailCC / data.aliasEmailEnquiries
              ),
            },
            {
              name: "Brokered Leads",
              enqTotal: data.brokeredEnquiries,
              enqPercent:
                this.calculatePercent(
                  data.brokeredEnquiries,
                  data.enquiriesCount
                ) + "%",
              ccTotal: this.formatMoney(data.brokeredCC),
              ccPerEnq: this.formatMoney(
                data.brokeredCC / data.brokeredEnquiries
              ),
            },
            {
              name: "Other",
              enqTotal: data.otherEnquiries,
              enqPercent:
                this.calculatePercent(data.otherEnquiries, data.enquiriesCount) +
                "%",
              ccTotal: this.formatMoney(data.otherCC),
              ccPerEnq: this.formatMoney(data.otherCC / data.otherEnquiries),
            },
          ];
          if (this.gridApi != null) {
            this.setGridData(rowData);
          }
        }
      },
      calculatePercent(amount, total) {
        if (amount == 0) {
          return 0;
        }
        return parseFloat((parseInt(amount) / parseInt(total)) * 100).toFixed(1);
      },
      formatMoney(amount) {
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        return formatter.format(amount);
      },

      // AG GRID
      setGridData(data) {
        let rowData = JSON.parse(JSON.stringify(data));

        this.gridApi.setRowData(rowData);
        setTimeout(() => {}, 50);
      },
      onQuickFilterChanged() {
        clearTimeout(this.searchDebounce);

        this.searchDebounce = setTimeout(() => {
          this.gridApi.setQuickFilter(this.search);
        }, 150);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;

        this.formatRowData();
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("agGrid/setSelectedRowData", cell.data);
        this.viewStockDetails();
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("agGrid/setAGGridActionMenuState", {});
      },
      viewStockDetails() {},
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
</script>

<style lang="css">
</style>